import * as React from 'react';
import { resolve } from 'inversify-react';
import { observable, computed } from 'mobx';
import { observer } from 'mobx-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ControllerProps } from 'src/router';
import { DialogService } from 'src/core/services/ui/dialog.service';
import { ObjectUtils } from 'src/core/utils/object';
import { RulesFormView } from './rules-form.view';
import { RulesDataService } from './rules-form.data';
import { ContextService } from 'src/core/services/context.service';
import { ConfigurationService } from 'src/core/services/configuration.service';
import autobind from "autobind-decorator";
import { RuleOperationsService, IStackTraceMessage } from 'src/app/rules/rules/rule-services';

interface RulesFormParams {
	id: string
}

@observer
export class RulesFormController extends React.Component<ControllerProps<RulesFormParams>, { enabledRun: boolean
	refresh: boolean}>  {
	@resolve
	protected dialogService: DialogService;

	@observable
	protected dataService: RulesDataService;

	@resolve
	protected toast: ToastNotifications;


	@resolve
	contextService: ContextService;

	@resolve
	rulesService: RuleOperationsService;

	@observable
	mode: ControlMode = 'display';

	@observable
	event: PublicEventItem;


	@resolve
	protected configurationService: ConfigurationService;

	@observable
	defaultLanguaje: string;

	constructor(props) {
		super(props);
		this.state = {
			refresh: false,
			enabledRun: true
		}
	}

	@computed
	protected get title() {
		if (this.dataService && this.dataService.item) {
			return `Rule: ${this.dataService.item.name}`;
		}
		return "";
	}

	@autobind
	protected onModeChanged(mode: ControlMode) {
		this.mode = mode;
	}

	protected removeValidation(item: RuleItem) {


		if (item.dynamicProperties["conditions"])
			for (var cond of item.dynamicProperties.conditions)
				if (cond.conditionValues)
					if (cond.conditionValues.validate)
						delete cond.conditionValues.validate;

		if (item.dynamicProperties["branchExecutors"])
			for (var cond of item.dynamicProperties.branchExecutors)
				if (cond.conditionValues)
					if (cond.conditionValues.validate)
						delete cond.conditionValues.validate;

		if (item.dynamicProperties["alternativeExecutors"])
			for (var cond of item.dynamicProperties.alternativeExecutors)
				if (cond.conditionValues)
					if (cond.conditionValues.validate)
						delete cond.conditionValues.validate;
	}

	@autobind
	public async save() {
		const item = this.dataService.item;
		const errors = await item.validate(true);
		if (errors.length == 0) {
			this.props.setBusy(true);

			this.removeValidation(item);


			this.dataService.save()
				.then(() => {
					this.props.setBusy(false);
					this.onModeChanged('display');
					this.toast.showDataSaved();
				})
				.catch((error) => {
					this.props.setBusy(false);
					this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
				});
		} else {
			this.toast.showToast('Validation error!', errors.map(e => e.text), 'error');
		}
	}

	@autobind
	public cancel() {
		return new Promise<boolean>((resolve, reject) => {
			if (this.dataService.isDirty) {
				this.dialogService.showYesNo("Warning", "Are you sure want to close this form? Your changes will be lost!")
					.then(dialogResult => {
						if (dialogResult) {
							this.props.history.push("/rules/rules");
						}
						resolve(true);
					})
					.catch(reject);
			} else {

				this.props.history.push('/rules/rules');
				resolve(true);

			}
		});
	}
	@autobind
	protected create() {
		const item = this.dataService.add();
		return item;
	}

	@autobind
	protected runManually(): Promise<IStackTraceMessage> {

		this.props.setBusy(true);

		return new Promise<IStackTraceMessage>((resolve, reject) => {

			this.rulesService.runManually(this.dataService.item.id)
				.then(trace => {
					resolve(trace);
					this.props.setBusy(false);
				}).catch(err => {
					this.toast.showToast("Error", "Maybe the rule execution takes too long " + ObjectUtils.parseError(err), "error");
					reject(err);
					this.props.setBusy(false);
				});
		});
		
	}

	request() {
		this.props.setBusy(true);
		this.dataService = RulesDataService.make(this.contextService);
		this.configurationService.current()
			.then(res => {
				this.defaultLanguaje = res.defaultLanguage;
				if (this.props.match.params.id == "new") {
					// Create new
					this.dataService.create(this.create)
						.then(() => {
							this.mode = 'edit';

							this.props.setBusy(false);
						}).catch(error => {
							this.props.setBusy(false);
							this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
						});
				} else {
					// Load entity
					this.dataService.addFilter('id', 'eq', this.props.match.params.id);
					this.dataService.addSorting('id', 'asc', true);
					this.dataService.pageSize = 1;
					this.dataService.load(query => query)
						.catch((error) => {
							this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
						})
						.then(() => {

							this.rulesService.getEventDefinition(this.dataService.item.eventWrapperName).then(result => {
								this.event = result;
							});

							this.props.setBusy(false);
						});
				}
			});
	}


	componentDidMount() {
		this.request();	
	}

	render() {
		if (this.dataService == null || this.dataService.item == null) {
			return null;
		}
		
		return (
			<RulesFormView title={this.title}
				mode={this.mode}
				runManuallyEnabled={!this.dataService.isDirty}
				runManually={this.runManually}
				onModeChanged={this.onModeChanged}
				cancel={this.cancel}
				save={this.save}
				event={this.event}
				contextService={this.contextService}
				model={this.dataService.item}
				setBusy={this.props.setBusy}
				reloadEvents={() => this.request}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/form/rules-form.controller.tsx